import React from "react";
import Donate from "./Donate";
import InvestNow from "./InvestNow";
import Welcome from "./Welcome";
import CardRef from "./CardRef";
import CardValues from "./CardValues";

export default function Hero({ children }) {
  return (
    <>
      <Welcome />
      <div className="beams-header absolute inset-0 lg:top-[720px] top-[620px] bg-bottom bg-no-repeat bg-slate-50" />
      <InvestNow />
      <CardValues />
      <CardRef />
      <Donate />

      {/* SECTION 3 */}
    </>
  );
}
